export * from './LoadingPlaceholder';
export { MockImage, MockText, MockIcon, MockButton } from './LoadingPlaceholder.styled';

export { default } from './LoadingPlaceholder';
